import { useEffect, useRef } from 'react';
/**
 * useVisibilityListener
 *
 * Triggers the callback each time the referenced element becomes visible in the viewport.
 *
 * @param ref - React ref to the DOM element to observe
 * @param onVisible - Callback to trigger when the element is visible
 * @param options - IntersectionObserver options (optional)
 */
function useVisibilityListener(ref, onVisible, options) {
    const wasVisibleRef = useRef(false);
    useEffect(() => {
        const element = ref.current;
        if (!element)
            return;
        const observer = new window.IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const isVisible = entry.isIntersecting;
                if (!wasVisibleRef.current && isVisible) {
                    onVisible();
                }
                wasVisibleRef.current = isVisible;
            });
        }, options);
        observer.observe(element);
        return () => {
            observer.disconnect();
        };
    }, [ref, onVisible, options]);
}
export default useVisibilityListener;
